module.exports = __webpack_public_path__ + "img/publish.7009655f.png";